import { lazyNamed, lazyPage } from "utils/lazyPage";

// Pages are loaded on demand: each feature becomes its own chunk, so the first
// load only ships the shell (auth, route guards, layouts, theme). Loading
// shows the global loader (routes/PageSuspense). See utils/lazyPage.

// Public pages
export const WelcomeScreen = lazyPage(() => import("components/layout/WelcomeScreen"));
export const LocalURL = lazyPage(() => import("components/layout/local"));

const loadLogin = () => import("features/login");
export const LoginContainer = lazyNamed(loadLogin, "LoginContainer");
export const LoginVerifyContainer = lazyNamed(loadLogin, "LoginVerifyContainer");

const loadSignup = () => import("features/signup");
export const SignupContainer = lazyNamed(loadSignup, "SignupContainer");
export const SignupVerifyContainer = lazyNamed(loadSignup, "SignupVerifyContainer");
export const SignupVerifyCompleteContainer = lazyNamed(loadSignup, "SignupVerifyCompleteContainer");
export const SignupCompleteContainer = lazyNamed(loadSignup, "SignupCompleteContainer");

// District home and settings
const loadDashboard = () => import("components/layout/dashboard");
export const DistrictDashboard = lazyNamed(loadDashboard, "DistrictDashboard");

const loadSettings = () => import("components/layout/InternalLayout");
export const Settings = lazyNamed(loadSettings, "Settings");
export const Directory = lazyNamed(loadSettings, "Directory");
export const OnboardingDirectory = lazyNamed(loadSettings, "OnboardingDirectory");

const loadDistricts = () => import("features/districts");
export const EditDistrict = lazyNamed(loadDistricts, "EditDistrict");
export const OnboardDistrictContainer = lazyNamed(loadDistricts, "OnboardDistrictContainer");

const loadProfileSetting = () => import("features/profileSetting");
export const ProfileSettingContainer = lazyNamed(loadProfileSetting, "ProfileSettingContainer");

// Users (Active Directory)
export const ActiveDirectoryLayout = lazyPage(() => import("features/activeDirectory/containers/ActiveDirectoryLayout"));
const loadActiveDirectory = () => import("features/activeDirectory");
export const ActiveDirectoryContainer = lazyNamed(loadActiveDirectory, "ActiveDirectoryContainer");
export const EditActiveDirectory = lazyNamed(loadActiveDirectory, "EditActiveDirectory");
export const AssignTagActiveDirectoryContainer = lazyNamed(loadActiveDirectory, "AssignTagActiveDirectoryContainer");

// Schools
const loadCampus = () => import("features/campus");
export const CampusContainer = lazyNamed(loadCampus, "CampusContainer");
export const AddCampus = lazyNamed(loadCampus, "AddCampus");
export const EditCampus = lazyNamed(loadCampus, "EditCampus");
export const ViewCampusLayout = lazyNamed(loadCampus, "ViewCampusLayout");
export const OnboardCampusContainer = lazyNamed(loadCampus, "OnboardCampusContainer");

const loadBuildings = () => import("features/buildings");
export const BuildingsContainer = lazyNamed(loadBuildings, "BuildingsContainer");
export const AddBuilding = lazyNamed(loadBuildings, "AddBuilding");
export const EditBuilding = lazyNamed(loadBuildings, "EditBuilding");

// Domains
const loadDomain = () => import("features/domain");
export const DomainLayout = lazyNamed(loadDomain, "DomainLayout");
export const DomainContainer = lazyNamed(loadDomain, "DomainContainer");
export const AddDomainContainer = lazyNamed(loadDomain, "AddDomainContainer");
export const DomainUserContainer = lazyNamed(loadDomain, "DomainUserContainer");
export const DomainLEContainer = lazyNamed(loadDomain, "DomainLEContainer");

// Incidents
const loadIncidents = () => import("features/incidents");
export const IncidentContainer = lazyNamed(loadIncidents, "IncidentContainer");

// Settings pages
const loadInternalAdmin = () => import("features/internalAdmin");
export const InternalAdminContainer = lazyNamed(loadInternalAdmin, "InternalAdminContainer");
export const InviteAdminContainer = lazyNamed(loadInternalAdmin, "InviteAdminContainer");
export const OnboardAdminContainer = lazyNamed(loadInternalAdmin, "OnboardAdminContainer");
export const SuccessContainer = lazyNamed(loadInternalAdmin, "SuccessContainer");

const loadPolicies = () => import("features/internalPolicies");
export const InternalPoliciesContainer = lazyNamed(loadPolicies, "InternalPoliciesContainer");

const loadTags = () => import("features/internalTags");
export const InternalTagsContainer = lazyNamed(loadTags, "InternalTagsContainer");
export const AddTagContainer = lazyNamed(loadTags, "AddTagContainer");

const loadLockdown = () => import("features/lockdownStage");
export const LockdownStageContainer = lazyNamed(loadLockdown, "LockdownStageContainer");
